import useFullSizeModalRouteUpdater from 'hooks/useFullSizeModalRouteUpdater'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { ModalSizeModeEnum } from 'UIKit/AlchemyModal/Modal'
import { ModalProps } from 'UIKit/Modal'
import { PAYMENT_MODAL_THEME, StylePaymentModal } from '../../styles'
import HistoryInfo from './HistoryInfo'

const FindDepositModal: React.FC<ModalProps> = ({ onDismiss }) => {
  const onBack = useFullSizeModalRouteUpdater('FD', onDismiss)
  const { t } = useTranslation()

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onBack} sizeMode={ModalSizeModeEnum.Full}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} title={t('Find Deposit')} onBack={onBack} useBackIcon hideClose />
      <ModalBody gap="var(--pm-space-component, 20px)" overflowY="auto">
        <HistoryInfo />
      </ModalBody>
    </StylePaymentModal>
  )
}

export default FindDepositModal
